export const convertRatingValueToOneDecimal = (rating: number | undefined) => {
  return (Math.round(((rating || 0) + Number.EPSILON) * 10) / 10).toFixed(1);
};
